export interface BaseFullEmployeeFormDomainParams {
  groupId: string;
  periodId: string;
  subscriberId?: string;
  activeTabId?: string;
}

export enum TabId {
  EMPLOYEE_PROFILE = 'employee-profile',
  DEPENDENTS = 'dependents',
  ELECTIONS = 'elections',
}

export const FULL_FORM_TABS_WITH_ELECTIONS = [TabId.EMPLOYEE_PROFILE, TabId.DEPENDENTS, TabId.ELECTIONS] as const;

export const FULL_FORM_TABS_WITHOUT_ELECTIONS = [TabId.EMPLOYEE_PROFILE, TabId.DEPENDENTS] as const;
